import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Resize } from 'vuetify/lib/directives';
import UnderConstruction from '@/components/Icons/UnderConstruction'
import UnderConstructionWhite from '@/components/Icons/UnderConstructionWhite'
import CleanupAlert from '@/components/Icons/CleanupAlert'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
    values: {
      under_construction: {
        component: UnderConstruction
      },
      under_construction_white: {
        component: UnderConstructionWhite
      },
      cleanup_alert: {
        component: CleanupAlert
      }
    }
  },
  theme: {
    themes: {
      light: {
        primary: '#00838F', // #1976D2 Default Vuetify
        secondary: '#424242',
        accent: '#26C6DA', // #82B1FF Default Vuetify
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
  directives: {
    Resize,
  },
});
